import React, { useState, useEffect } from 'react';
import SentenceExpansionApp from './components/SentenceExpansionApp';
import A2AServerToggle from './components/A2AServerToggle';
import { NotificationManager } from './components/Notification';
import a2aEnglishWritingService from './api/services/a2aEnglishService';
import './App.css';

function App() {
  const [uxFormat, setUxFormat] = useState(null);

  // UX Negotiation - Detect context and negotiate UX format
  useEffect(() => {
    const initializeUX = async () => {
      try {
        // Detect user context
        const context = a2aEnglishWritingService.detectContext();
        console.log('[EnglishWritingTools] Detected context:', context);
        
        // Negotiate UX format via A2A
        const negotiatedUX = await a2aEnglishWritingService.negotiateUX(context);
        console.log('[EnglishWritingTools] Negotiated UX format:', negotiatedUX);
        
        setUxFormat(negotiatedUX);
      } catch (error) {
        console.error('[EnglishWritingTools] Error during UX negotiation:', error);
        // Use default UX format on error
        const defaultContext = a2aEnglishWritingService.detectContext();
        const isMobile = defaultContext.device === 'mobile' || defaultContext.screen_width < 768;
        const isSlowNetwork = ['2g', '3g'].includes(defaultContext.bandwidth);
        const defaultUX = {
          layout: isMobile ? 'cards' : 'table',
          font_size: isMobile ? 'large' : 'medium',
          character_set: defaultContext.preferred_language || 'english',
          show_pinyin: false,
          max_items_per_page: isMobile ? 5 : 10,
          enable_lazy_loading: isSlowNetwork || isMobile
        };
        setUxFormat(defaultUX);
      }
    };
    
    initializeUX();
  }, []);

  return (
    <div 
      className={`App ${
        uxFormat?.font_size === 'large' ? 'text-lg' : 
        uxFormat?.font_size === 'small' ? 'text-sm' : 
        'text-base'
      }`}
    >
      <NotificationManager />
      <SentenceExpansionApp uxFormat={uxFormat} />
      <A2AServerToggle />
    </div>
  );
}

export default App;
